import React, { useEffect } from 'react'
import "./siteCookiesModal.scss"
import { Modal } from 'react-bootstrap'
import Button from '../Button/Button';
import Cookies from 'js-cookie';

interface SiteCookiesModalProps {
  show: boolean;
  cookiesHide: () => void;
  onAccept: () => void;
  onReject: () => void;
  onSettings: () => void;
}

const SiteCookiesModal: React.FC<SiteCookiesModalProps> = ({ cookiesHide, onAccept, onReject, onSettings, ...props }) => {

  useEffect(() => {
    const savedConsent = Cookies.get('cookieConsent');
    if (savedConsent) {
      cookiesHide();
    }
  }, []);

  return (
    <Modal
      {...props}
      aria-labelledby="site-cookies-modal"
      onHide={cookiesHide}
      backdrop="static"
      className='site-cookies-modal'
    >
      <Modal.Body>
        <div className='row'>
          <div className='col-xxl-7 col-xl-6'>
            <div className='site-cookies-wrapper'>
              <p>We use cookies to operate our site, and for measurement, analytics, advertising and fraud detection. By using this site you agree to our <a href="https://www.renticy.com/cookie-policy/" target="_blank" rel="noopener noreferrer" className='site-link'>cookie policy</a></p>
            </div>
          </div>
          <div className='col-xxl-5 col-xl-6'>
            <div className="row justify-content-md-end gx-2">
              {/* <div className="col-sm-4">
                  <Button btnText='Cookies settings' onClick={() => setSettingsModalShow(true)} className='btn-secondary' />
                </div> */}
              <div className="col-sm-4">
                <Button btnText='Only Essential cookies' onClick={onAccept} />
              </div>
              <div className="col-sm-4">
                <Button btnText='Accept all Cookies' onClick={onAccept} className='m-0' />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SiteCookiesModal